import React from 'react'
import { createRoot } from 'react-dom/client'
import ContentManager from './components/ContentManager'

export let startContentCustomizer = (coursenum, chapters) => {
  const root = createRoot(document.getElementById('content-customizer'))
  root.render(<ContentManager coursenum={coursenum} chapters={chapters} />)
}
